import axios from 'axios'
import Swal from 'sweetalert2'
import {  verifyOtp, verifyOtpObligatorioWebsal, verifyOtpWebsal } from '../../hooks/UseVerifyOtp'
import {  baseUrl, baseUrlback } from '../../urlApi'




export const SIGN_IN = 'SIGN_IN'
export const LOG_OUT = 'LOG_OUT'
export const RENOV = 'RENOV'
export const LOADING = 'LOADING'
export const MFA = 'MFA'
export const VALIDARMFA = 'VALIDARMFA'
export const SIGN_IN_REPRESENTANTE = 'SIGN_IN_REPRESENTANTE'

export const loadingAction = () => ({
  type:LOADING,

})

export const validarOtp = () => {
  return async (dispatch,getstate) => {
    dispatch({
      type:VALIDARMFA,
     })
  }
}


export const log = (pe,px,setLoading,navigate) => {


     return async (dispatch,getstate) => {

       


      localStorage.clear()


      const so ='pc'

    
            try {
                
             
              // console.log('ola')

                const response = await axios.post(`${baseUrl}login.asp`, { pe,px,so });

                // console.log(response,'response')
       
     
                          if(response.data === ''){
                            Swal.fire({
                              title: 'Datos incorrectos',
                              text: 'Intentalo otra vez',
                              confirmButtonColor:'#2ec1db',
                              
                            })
                            setLoading(false)

                            return 
                          }

                      
                
                const verify = await verifyOtp(pe)
                 
                //  console.log(verify,'verifyverifyverify')
             
                if(verify?.otp_enabled === 1 ){

                  // console.log('preguntame')

                  dispatch({
                    type:MFA,
                    payload:response.data,
                    token:response.data.strCon,
                    representante:false
                   })

                  //  localStorage.setItem('token', response.data.strCon)
                   localStorage.setItem('nombre', response.data.nombre)
                   localStorage.setItem('empresaId', response.data.empresaId)
                   localStorage.setItem('empresa', response.data.razsonSocial)
                   localStorage.setItem('email', response.data.email)
                   localStorage.removeItem('conid')
                   localStorage.setItem('conid', pe)
                   localStorage.setItem('appUser', 'colaborador')
                   

                  // Cookies.set('autoconsulta', true ,  {expires: 0.38}   )


                  


                   navigate('/mfa')
                   return 
                }

             
                
                if(response.data.nombre){
                    
                   

                    dispatch({
                        type:SIGN_IN,
                        payload:response.data,
                        token:response.data.strCon,
                        autenticado: 'autorizado',
                      
                    })

                     localStorage.setItem('token', response.data.strCon)
                     localStorage.setItem('nombre', response.data.nombre)
                     localStorage.setItem('empresaId', response.data.empresaId)
                     localStorage.setItem('empresa', response.data.razsonSocial)
                     localStorage.setItem('email', response.data.email)
                     localStorage.removeItem('conid')
                     localStorage.setItem('conid', pe)
                    

 
                     localStorage.setItem('appUser', 'colaborador')

                
                 

                   
                } else {
                  Swal.fire({
                    title: 'Datos incorrectos',
                    text: 'Intentalo otra vez',
                    confirmButtonColor:'#2ec1db',
                    
                  })
                  setLoading(false)
                
                  // dispatch(loadingAction())

                }
                    
        
              } catch (error) {
                console.error(error);
                // dispatch(loadingAction())
                setLoading(false)
              }

               


     }
    

}


export const log_out = () => ({
    type:LOG_OUT,



})



export const renuew =(desdePrimeraVez = false) => {
    return async (dispatch,getstate) => {


      try {
        const strcon = localStorage.getItem('token')

        
        // console.log('tokeeeeen',strcon)

        if(!strcon) return dispatch({
            type:LOG_OUT
        })

        const response = await axios.post(`${baseUrl}datos.asp`,
         {
            strcon
         });
               
              if(response.data.nombre && !desdePrimeraVez ){

                response.data.emailok = localStorage.getItem("emailok")


                dispatch({
                  type:SIGN_IN,
                  payload:response.data,
                  token:strcon,

                })
              

              }else if(response.data.nombre && desdePrimeraVez ){

                
                    response.data.emailok = 'N'

                    dispatch({
                      type:SIGN_IN,
                      payload:response.data,
                      token:strcon,

                    })


              }else{
                  dispatch({
                      type:LOG_OUT
                  })
              }
        //  console.log('respuesta',response.status);


            
        } catch (error) {
          

          console.log(error)
          dispatch({
            type:LOG_OUT
        })
            
        }
    }
   
}




export const logRepresentante = (portal,usuario,px ,setLoading ='', navigate ) => {
  return async (dispatch,getstate) => {


                    
 
         try {
             const response = await axios.post(`${baseUrlback}api/helpers/loginRepresentantesApp`,
             {
                 portal,usuario,password:px
             });

             const {sid,codigo,tipo,email,strcon,perid,decrypt} = response.data


             localStorage.setItem('codigo',codigo)   
             localStorage.setItem('decrypt',decrypt)       
             localStorage.setItem('tipo',tipo)       
             localStorage.setItem('sid',`${sid}`)
             localStorage.setItem('strcon',strcon)
             localStorage.setItem('email',email)
             localStorage.setItem('perid',perid)
             localStorage.setItem('portal',response.data.portal)                
             localStorage.setItem('usuario', usuario)

             localStorage.setItem('appUser', 'representante')

             
             localStorage.setItem('dataUsuario', JSON.stringify(response.data) )
             


             const [verifyOblitatorio] =  await verifyOtpObligatorioWebsal(sid)

         
          
             const verify = await verifyOtpWebsal(sid,usuario)
              
  

             if(verify?.otp_enabled !== 1 && verifyOblitatorio.mfa === 'S' ){



              Swal.fire({
                title: 'MFA obligatorio en este portal',
                text: 'Inicia sesión en remuneraciones para configurarlo',
                confirmButtonColor:'#2ec1db',
              })
              localStorage.clear()
              setLoading(false)
              return 

             }

              // Verificamos si tiene MFA, si tiene lo mandamos a la screen en donde se lo solicitamos
             if(verify?.otp_enabled === 1 && verifyOblitatorio.mfa === 'S' ){

               
                 response.data.otp_enabled = true

               

                dispatch({
                  type:MFA,
                  payload:response.data,
                  token:response.data.strcon,
                  representante:true
                  })
                

                 setLoading(false)
                // await navigation.replace('Mfa')
                navigate('/mfa') 

                
                
                return 
             }

               localStorage.setItem('vencimiento', `${Date.now()}`)
          


                 dispatch({
                     type:SIGN_IN_REPRESENTANTE,
                     payload:response.data,
                     token:response.data.strcon,
                     autenticado: 'autorizado',
                     
                     
                 })
                 
              
          
                 
     
           } catch (error) {
             console.error(error);
             setLoading(false)
           

             Swal.fire({
              title: 'Datos incorrectos',
              text: 'Intentalo otra vez',
              confirmButtonColor:'#2ec1db',
              
            })

           }




  }
 

}



export const renuewRepresentante = () => {

  return async (dispatch,getstate) => {


    const dateNow = Date.now()

    const fechaLogin = localStorage.getItem('vencimiento')

    if(!fechaLogin) {
          dispatch({
            type:LOG_OUT
          })
    }

    // 3600000
    if( Number(fechaLogin) + 3600000 < dateNow ){

          dispatch({
            type:LOG_OUT
        })


      return
    } 


   const dataUsuarioString = localStorage.getItem('dataUsuario')

   const dataUsuarioParsed = JSON.parse(dataUsuarioString)

        dispatch({
          type:SIGN_IN_REPRESENTANTE,
          payload:dataUsuarioParsed,
          token:dataUsuarioParsed.strcon,
          autenticado: 'autorizado',
          
      })
    



  }


}